import { FieldErrors, UseFormRegister } from "react-hook-form";
import { CreateEmpresa } from "../types";
import { InputCreateEmpresaForm } from "../../../../components/ui/InputCreateEmpresaForm";

interface Props {
    register: UseFormRegister<CreateEmpresa>;
    errors: FieldErrors<CreateEmpresa>;
}

export function ContactoSection({ register, errors }: Props) {
    return (
        <div className="flex gap-x-2">
            <div className="w-[200px]">
                <p className="text-xl font-semibold">Contactos</p>
            </div>

            <div>

                <div className="flex gap-x-4 mb-2">
                    <div>
                        <InputCreateEmpresaForm
                            height="h-[35px]"
                            width="w-[300px]"
                            label="Nombre"
                            register={register("contactos.nombre", {
                                required: "El nombre del contacto es requerido",
                                maxLength: 50,
                            })}/>
                        <div className="h-[20px]">
                            {errors.contactos?.nombre?.type === "required" && (
                                <p className="valErrorText text-sm">{errors.contactos.nombre.message}</p>
                            )}
                            {errors.contactos?.nombre?.type === "min" && (
                                <p className="valErrorText text-sm">Número máximo de caracteres es 50</p>
                            )}
                        </div>
                    </div>

                    <div>
                        <InputCreateEmpresaForm 
                            height="h-[35px]"
                            width="w-[300px]"
                            label="Puesto"
                            register={register("contactos.puesto", {
                                maxLength: 30,
                            })}/>
                        <div className="h-[20px]">
                            {errors.contactos?.puesto?.type === "maxLength" && (
                                <p className="valErrorText text-sm">Número máximo de caracteres es 50</p>
                            )}
                        </div>
                    </div>

                    <div>
                        <InputCreateEmpresaForm 
                            height="h-[35px]"
                            width="w-[300px]"
                            label="Correo"
                            register={register("contactos.correo", {
                                maxLength: 100,
                            })}/>
                        <div className="h-[20px]">
                            {errors.contactos?.correo?.type === "maxLength" && (
                                <p className="valErrorText text-sm">Número máximo de caracteres es 100</p>
                            )}
                        </div>
                    </div>
                </div>

                <div className="flex gap-x-4 mb-2">
                    <div>
                        <InputCreateEmpresaForm 
                            height="h-[35px]"
                            width="w-[458px]"
                            label="Telefono de la empresa"
                            register={register("contactos.telefonoEmpresa", {
                                required: "Al menos un telefono tiene que ser agregado al contacto",
                                maxLength: 10,
                            })}/>
                        <div className="h-[20px]">
                            {errors.contactos?.telefonoEmpresa?.type === "required" && (
                                <p className="valErrorText text-sm">{errors.contactos.telefonoEmpresa.message}</p>
                            )}
                            {errors.contactos?.telefonoEmpresa?.type === "maxLength" && (
                                <p className="valErrorText text-sm">Número máximo de caracteres es 10</p>
                            )}
                        </div>
                    </div>

                    <div>
                        <InputCreateEmpresaForm 
                            height="h-[35px]"
                            width="w-[458px]"
                            label="Telefono personal"
                            register={register("contactos.telefonoPersonal", {
                                maxLength: 10,
                            })}/>
                        <div className="h-[20px]">
                            {errors.contactos?.telefonoPersonal?.type === "maxLength" && (
                                <p className="valErrorText text-sm">Número máximo de caracteres es 10</p>
                            )}
                        </div>
                    </div>
                </div>

                <div className="flex gap-x-4 mb-2">
                    <div className="grid">
                        <label className="text-sm font-semibold">Comentarios</label>
                        <textarea
                            {...register("contactos.comentarios")}
                            className="
                                w-[932px] h-[100px] rounded-[3px] border-gray-400 border my-1 px-2 
                                font-semibold text-gray-600 text-sm resize-none">
                        </textarea>
                    </div>
                </div>
            </div>

        </div>
    );
}
